// Toast queue rendered by components/layout/Toasts.svelte (bottom centre, Bulma notification colours).

/** @typedef {'success' | 'warning' | 'danger' | 'info'} ToastType */
/** @typedef {{ id: number, text: string, type: ToastType, timeout: number }} Toast */

let nextId = 1;

class ToastStore {
	/** @type {Toast[]} */
	items = $state([]);

	/**
	 * @param {string} text
	 * @param {ToastType} [type]
	 * @param {number} [timeout] ms; 0 keeps it until dismissed
	 */
	push(text, type = 'warning', timeout = 5000) {
		const id = nextId++;
		this.items.push({ id, text, type, timeout });
		if (timeout > 0 && typeof setTimeout === 'function') {
			setTimeout(() => this.dismiss(id), timeout);
		}
		return id;
	}

	/** @param {number} id */
	dismiss(id) {
		const index = this.items.findIndex((t) => t.id === id);
		if (index !== -1) this.items.splice(index, 1);
	}

	clear() {
		this.items.length = 0;
	}

	/** @param {string} text @param {number} [timeout] */
	success(text, timeout = 4000) {
		return this.push(text, 'success', timeout);
	}

	/** @param {string} text @param {number} [timeout] */
	warning(text, timeout = 5000) {
		return this.push(text, 'warning', timeout);
	}

	/** @param {string} text @param {number} [timeout] */
	error(text, timeout = 6000) {
		return this.push(text, 'danger', timeout);
	}

	/** @param {string} text @param {number} [timeout] */
	info(text, timeout = 4000) {
		return this.push(text, 'info', timeout);
	}
}

export const toast = new ToastStore();
